export const ACCOUNT_UPDATE = "ACCOUNT_UPDATE";
export const WEB3_LOADED = "WEB3_LOADED";
export const ACCOUNT_UPDATE_ON_DISCONNECT = "ACCOUNT_UPDATE_ON_DISCONNECT";
export const SWAP_SUCCESS = "SWAP_SUCCESS"
export const SWAP_SUCCESS_RESET = "SWAP_SUCCESS_RESET"
export const ADD_LIQUIDITY_SUCCESS = "ADD_LIQUIDITY_SUCCESS"
export const ADD_LIQUIDITY_SUCCESS_RESET = "ADD_LIQUIDITY_SUCCESS_RESET"
export const STAKE_UNSTAKE_SUCCESS = "STAKE_UNSTAKE_SUCCESS"
export const STAKE_UNSTAKE_SUCCESS_RESET = "STAKE_UNSTAKE_SUCCESS_RESET"
export const REMOVE_LIQUIDITY_SUCCESS = "REMOVE_LIQUIDITY_SUCCESS"
export const REMOVE_LIQUIDITY_SUCCESS_RESET = "REMOVE_LIQUIDITY_SUCCESS_RESET"
export const GET_CONFIG = {
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
};
export const POST_CONFIG = {
  headers: {
    "Content-Type": "application/json",
  },
};

export const URL = "http://localhost:3001";
